import { ReactNode, useCallback } from 'react';
import Tooltip from '@/components/Tooltip';
import { Text } from '@simplywallst/ui-core';
import { StyledText } from './styled';

type Props = {
  title: ReactNode;
  term: string;
};

export const WithTooltip = ({ title, term }: Props) => {
  const muteEvent = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  return (
    <Tooltip title={title} light zIndex={1}>
      <Text
        as="span"
        typography="tiny"
        color="whiteRGBA"
        opacity={0.5}
        onTouchEnd={muteEvent}
        onClick={muteEvent}
      >
        <StyledText>{term}</StyledText>
      </Text>
    </Tooltip>
  );
};
